import {Component, OnInit} from '@angular/core';
import {GridIdentifier} from '@application/grids/grid-identifier.enum';
import {CrudActions} from '@application/helper/grid-action-buttons-helper/crud-actions.interface';
import {GridActionButtonsHelper} from '@application/helper/grid-action-buttons-helper/grid-action-buttons-helper';
import {NavigationId} from '@application/helper/routing/navigation-id.enum';
import {NavigationUtils} from '@application/helper/routing/navigation-utils';
import {Schedule} from '@domain/calendar/schedule/schedule';
import {HttpSchedulesService} from '@infrastructure/http/calendar/schedule/http-schedules.service';
import {
  AssertionUtils,
  ContentSwitcherNavigationInput,
  CrudOverviewDataBuilderFactoryService,
  CrudOverviewDataConfig,
  GridButtonClickedEvent,
  GridOptionsBuilder,
  NavigationHelperPrototypeService
} from '@vdw/angular-component-library';
import {ScheduleCustomSettingsComponent} from '../settings/schedule-custom-settings.component';
import {ScheduleOverviewService} from './schedule-overview.service';

@Component({
  templateUrl: './schedule-overview-page.component.html'
})
export class ScheduleOverviewPageComponent implements OnInit {
  public config: CrudOverviewDataConfig<Schedule>;

  public constructor(
    private readonly crudOverviewDataBuilderFactory: CrudOverviewDataBuilderFactoryService<Schedule>,
    private readonly gridActionButtonsHelper: GridActionButtonsHelper,
    private readonly navigationHelperService: NavigationHelperPrototypeService,
    private readonly schedules: HttpSchedulesService,
    private readonly scheduleOverviewService: ScheduleOverviewService
  ) {}

  public ngOnInit(): void {
    const colDefs = this.scheduleOverviewService.getColumnDefs();

    this.config = this.crudOverviewDataBuilderFactory
      .getBuilder()
      .withRowData(this.schedules.getAll())
      .withDefaultButtons({
        crudOverviewButtonConfigs: this.gridActionButtonsHelper.getActionButtonsForGridSelection({
          requiredPermissionToEdit: NavigationUtils.getNavigationData(NavigationId.EDIT_SCHEDULE).requiredPermission,
          withEdit: (grid: GridButtonClickedEvent) => this.navigateToGivenRoute(grid, NavigationId.EDIT_SCHEDULE)
        } as CrudActions)
      })
      .withGridOptions(colDefs, GridIdentifier.SCHEDULE_OVERVIEW, null, (builder: GridOptionsBuilder) =>
        this.scheduleOverviewService.getDefaultGridOptionsBuilder(builder).withRowSelection(false, false).build()
      )
      .withEntityName(NavigationUtils.getNavigationData(NavigationId.SCHEDULE_MODULE).navigationKey)
      .withNewClicked(() => this.navigationHelperService.navigateWithRoute({route: NavigationUtils.getAbsolutePath(NavigationId.ADD_SCHEDULE)}))
      .withCustomSettingsClicked(() => this.openCustomSettings())
      .build();
  }

  private navigateToGivenRoute({gridApi, rowNode}: GridButtonClickedEvent, navigationId: NavigationId): void {
    this.navigationHelperService.navigateWithRoute({
      route: NavigationUtils.getAbsolutePath(navigationId).replace(':id', AssertionUtils.isNullOrUndefined(rowNode) ? gridApi?.getSelectedRows()[0].id : rowNode.id)
    });
  }

  private openCustomSettings(): void {
    const componentInfo = {
      componentInfo: {
        component: ScheduleCustomSettingsComponent
      }
    } as ContentSwitcherNavigationInput;

    this.navigationHelperService.navigateWithContentSwitcher(componentInfo);
  }
}
